<div class="ws-popup-header">
    <span *ngIf="isWarning">{{ text }}</span>
  <div class="actions">
      <button (click)="closeClicked()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="description-wrapper">
    <p class="bold" [innerHTML]="text | translate"></p>
    <p *ngFor="let item of items">
      <span [innerHTML]="item"></span>
    </p>
  </div>
</div>

<div *ngIf="isAction" class="ws-popup-footer">
    <span></span>
    <div class="actions-footer">
        <ws-button (click)="saveClicked()" [callToActionType]="'primary'">
            {{actionText}}
        </ws-button>
  </div>
</div>